(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["curated-edit"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sections = document.querySelectorAll('[data-sce-section]');
  if (!sections.length) return;

  sections.forEach((root) => {
    const track = root.querySelector('[data-sce-track]');
    const slides = Array.from(root.querySelectorAll('[data-sce-slide]'));
    const dotsWrap = root.querySelector('[data-sce-dots]');

    if (!track || !slides.length || !dotsWrap) return;

    const buildDots = () => {
      dotsWrap.innerHTML = '';

      slides.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'sce__dot' + (index === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', `Go to slide ${index + 1}`);

        dot.addEventListener('click', () => {
          track.scrollTo({
            left: slides[index].offsetLeft,
            behavior: 'smooth'
          });
        });

        dotsWrap.appendChild(dot);
      });
    };

    const setActiveDot = () => {
      const trackRect = track.getBoundingClientRect();
      const trackCenter = trackRect.left + trackRect.width / 2;

      let closestIndex = 0;
      let closestDistance = Infinity;

      slides.forEach((slide, index) => {
        const rect = slide.getBoundingClientRect();
        const slideCenter = rect.left + rect.width / 2;
        const distance = Math.abs(trackCenter - slideCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      dotsWrap.querySelectorAll('.sce__dot').forEach((dot, index) => {
        dot.classList.toggle('is-active', index === closestIndex);
      });
    };

    buildDots();
    setActiveDot();

    let rafId = null;
    track.addEventListener('scroll', () => {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(setActiveDot);
    });

    window.addEventListener('resize', setActiveDot);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sectionRoot = document.currentScript?.closest('.shopify-section') || document;
  const header = sectionRoot.querySelector('[data-wc-header]');
  if (!header) return;

  const openMenuBtn = header.querySelector('[data-wc-menu-open]');
  const closeMenuBtn = header.querySelector('[data-wc-menu-close]');
  const backdrop = header.querySelector('[data-wc-backdrop]');
  const drawer = header.querySelector('[data-wc-drawer]');
  const drawerPanel = header.querySelector('[data-wc-drawer-panel]');

  const cartBadges = header.querySelectorAll('[data-wc-cart-badge]');
  const cartOpenTriggers = header.querySelectorAll('[data-wc-cart-open]');
  const cartDrawerComponent = header.querySelector('cart-drawer-component');
  const cartDrawerDialog = header.querySelector('#wc-cart-dialog');

  let scrollY = 0;

  function lockScroll() {
    scrollY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.classList.add('wc-header-scroll-lock');
    document.body.classList.add('wc-header-scroll-lock');
    document.body.style.top = `-${scrollY}px`;
  }

  function unlockScroll() {
    document.documentElement.classList.remove('wc-header-scroll-lock');
    document.body.classList.remove('wc-header-scroll-lock');
    document.body.style.top = '';
    window.scrollTo(0, scrollY);
  }

  function closeMenu() {
    header.classList.remove('wc-header--open');
    if (drawer) drawer.setAttribute('hidden', '');
    if (backdrop) backdrop.setAttribute('hidden', '');
    unlockScroll();
  }

  function openMenu() {
    header.classList.add('wc-header--open');
    if (drawer) drawer.removeAttribute('hidden');
    if (backdrop) backdrop.removeAttribute('hidden');
    lockScroll();
  }

  if (openMenuBtn) openMenuBtn.addEventListener('click', openMenu);
  if (closeMenuBtn) closeMenuBtn.addEventListener('click', closeMenu);
  if (backdrop) backdrop.addEventListener('click', closeMenu);

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) closeMenu();
    });
  }

  if (drawerPanel) {
    drawerPanel.addEventListener('click', function (e) {
      e.stopPropagation();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenu();
  });

  function setCartBadges(count) {
    cartBadges.forEach(function (badge) {
      badge.textContent = String(count);
      badge.hidden = !count;
    });
  }

  async function refreshBadge() {
    try {
      const res = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });
      if (!res.ok) return;
      const data = await res.json();
      setCartBadges(data.item_count || 0);
    } catch (_) {
      /* silent */
    }
  }

  function openCart() {
    if (cartDrawerComponent && typeof cartDrawerComponent.open === 'function') {
      cartDrawerComponent.open();
      return;
    }
    if (cartDrawerDialog && typeof cartDrawerDialog.showModal === 'function') {
      cartDrawerDialog.showModal();
    }
  }

  cartOpenTriggers.forEach(function (btn) {
    btn.addEventListener('click', openCart);
  });

  // Fix: the theme's own cart pipeline (product-form.js, quick-add.js, cart-drawer.js, etc.)
  // dispatches 'cart:update' (see assets/events.js -> ThemeEvents.cartUpdate = 'cart:update')
  // whenever the cart changes. This header was only listening for 'cart:refresh',
  // 'cart:updated', and 'cart:change' -- none of which are ever actually dispatched by the
  // theme -- so the badge never updated in real time and only looked correct after a full
  // page reload (when refreshBadge() runs once on load). Listen for the real event name too.
  document.addEventListener('cart:update', refreshBadge);
  document.addEventListener('cart:refresh', refreshBadge);
  document.addEventListener('cart:updated', refreshBadge);
  document.addEventListener('cart:change', refreshBadge);

  refreshBadge();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
